__turbopack_context__.v({
  "answer": "FaqAnswer-module-scss-module__BG0Dpq__answer",
  "feedback-btn": "FaqAnswer-module-scss-module__BG0Dpq__feedback-btn",
  "feedback-heading": "FaqAnswer-module-scss-module__BG0Dpq__feedback-heading",
  "question-feedback": "FaqAnswer-module-scss-module__BG0Dpq__question-feedback",
});
